const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.46 17H3.7V1.8H5.46V17ZM10.6163 6.28V17H8.85625V6.28H10.6163ZM9.75625 2.26C10.0229 2.26 10.2563 2.35333 10.4563 2.54C10.6696 2.71333 10.7763 2.99333 10.7763 3.38C10.7763 3.75333 10.6696 4.03333 10.4563 4.22C10.2563 4.40667 10.0229 4.5 9.75625 4.5C9.46292 4.5 9.21625 4.40667 9.01625 4.22C8.81625 4.03333 8.71625 3.75333 8.71625 3.38C8.71625 2.99333 8.81625 2.71333 9.01625 2.54C9.21625 2.35333 9.46292 2.26 9.75625 2.26ZM25.7725 6.08C26.9858 6.08 27.8925 6.39333 28.4925 7.02C29.0925 7.63333 29.3925 8.63333 29.3925 10.02V17H27.6525V10.1C27.6525 9.26 27.4725 8.62667 27.1125 8.2C26.7658 7.77333 26.2192 7.56 25.4725 7.56C24.4325 7.56 23.6858 7.86 23.2325 8.46C22.7925 9.06 22.5725 9.93333 22.5725 11.08V17H20.8325V10.1C20.8325 9.54 20.7525 9.07333 20.5925 8.7C20.4325 8.31333 20.1925 8.02667 19.8725 7.84C19.5525 7.65333 19.1392 7.56 18.6325 7.56C17.9125 7.56 17.3458 7.71333 16.9325 8.02C16.5192 8.31333 16.2192 8.74667 16.0325 9.32C15.8592 9.89333 15.7725 10.6 15.7725 11.44V17H14.0125V6.28H15.4325L15.6925 7.74H15.7925C16.0192 7.36667 16.2925 7.06 16.6125 6.82C16.9458 6.56667 17.3125 6.38 17.7125 6.26C18.1125 6.14 18.5258 6.08 18.9525 6.08C19.7792 6.08 20.4658 6.22667 21.0125 6.52C21.5725 6.81333 21.9792 7.26667 22.2325 7.88H22.3325C22.6925 7.26667 23.1792 6.81333 23.7925 6.52C24.4192 6.22667 25.0792 6.08 25.7725 6.08Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.1477 25.3002C18.2677 25.0442 18.3837 24.8202 18.4957 24.6282C18.6157 24.4362 18.7317 24.2762 18.8437 24.1482H11.8477V23.6442H18.8437C18.7317 23.5082 18.6157 23.3442 18.4957 23.1522C18.3837 22.9602 18.2677 22.7402 18.1477 22.4922H18.5677C19.0717 23.0762 19.5997 23.5082 20.1517 23.7882V24.0042C19.5997 24.2762 19.0717 24.7082 18.5677 25.3002H18.1477Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.6484 23.4443H18.4502C18.4098 23.3847 18.3671 23.3232 18.3262 23.2578L18.3232 23.2529C18.2081 23.0556 18.0895 22.8307 17.9678 22.5791L17.8291 22.292H18.6592L18.7197 22.3613C19.2106 22.9301 19.7185 23.3437 20.2422 23.6094L20.3516 23.665V24.1279L20.2402 24.1836C19.7184 24.4408 19.2114 24.8534 18.7207 25.4297L18.6602 25.5H17.833L17.9668 25.2148C18.0886 24.9549 18.2076 24.7256 18.3232 24.5273L18.3262 24.5215C18.3645 24.4601 18.4053 24.4034 18.4434 24.3477H11.6484V23.4443ZM11.8477 24.1484H18.8438C18.7319 24.2764 18.616 24.4362 18.4961 24.6279L18.3252 24.9404C18.2673 25.0523 18.2083 25.172 18.1484 25.2998H18.5684L18.7578 25.0859C19.2042 24.6027 19.6692 24.242 20.1523 24.0039V23.7881C19.6004 23.5081 19.0723 23.076 18.5684 22.4922H18.1484C18.2684 22.7401 18.3841 22.9604 18.4961 23.1523C18.6159 23.344 18.7319 23.5077 18.8438 23.6436H11.8477V24.1484Z",
  fill: "#1E3F6B"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 3 29)",
  stroke: "#0081CC"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 23 29)",
  stroke: "#0081CC"
});

const SvgEquationLimit = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationLimit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-limit.779b6da5.svg";
export { ForwardRef as ReactComponent };